export default "__VITE_ASSET__CIn32yQ6__"